// Supabase project backing the BuildLab client portal — "affordablehousingpartner's
// Project" (shared project, BuildLab's own tables are namespaced buildlab_*).
// The anon/publishable key below is safe to ship in the client bundle: every
// buildlab_* table and the buildlab-files storage bucket enforce access with
// row-level security, not with secrecy of this key.
import { createClient } from '@supabase/supabase-js';

export const SUPABASE_URL = 'https://wmjwgomhslpaaxmvsmwv.supabase.co';
export const SUPABASE_ANON_KEY = 'sb_publishable_Y7G3ppbmvh4vU0aUPM3-fg_4g6gozSX';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
